module.exports = __webpack_public_path__ + "static/img/icon-tellus.d83f9219.svg";